import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Input from '../../../form/component/Input'
import DateOfBirth from '../../../form/component/DateOfBirth'
import ContentBox from '../../../layout/component/ContentBox'
import currentUserHasAccess from '../../../../util/widget-helper'
import {CUSTOMER_CONTACT_WIDGET} from '../../../process/ui-definition/process-ui'
import {lifecycle} from "recompose";

const CustomerContact = (
    {
        contact,
        changeCustomerContact,
        saveCustomerContact,
        salutationList,
        callNumber,
        countryCodeList,
        languageList,
        hydrateContact,
        error,
    }
) => {

    if (!currentUserHasAccess(CUSTOMER_CONTACT_WIDGET)) {
        return null
    }

    function formatPhoneNumber(e) {
        const phone = e.target.value;
        const pattern = new RegExp(/^\+?[0-9\b]+$/);
        if (!pattern.test(phone)) {
            const startsWithPlus = phone.startsWith('+');
            let formattedPhone;
            if (startsWithPlus) {
                formattedPhone = phone.replace(/(?!^)+[^0-9 ]/g, '');
            }
            else {
                formattedPhone = phone.replace(/[^0-9 ]/g, '');
            }
            changeCustomerContact('phone', formattedPhone);
        }
    }

    const [readOnly, setReadOnly] = useState(true);

    const [isVisible, setIsVisible] = useState(false);

    const [validationMsgList, setValidationMsgList] = useState({})

    const noop = () => {
    }

    function validate(e) {
        if (e.value.length === 0 || !e.value.trim()) {
            setValidationMsgList({...validationMsgList, [e.name]: 'Is mandatory field, please fill before save'})
            return
        }
        if (validationMsgList[e.name]) {
            setValidationMsgList({...validationMsgList, [e.name]: null})
        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const res = re.test(String(email).trim().toLowerCase());
        if (!res) {
            setValidationMsgList({...validationMsgList, email: 'email format not valid, please use a valid email'})
            return
        }
        if (validationMsgList.email) {
            setValidationMsgList({...validationMsgList, email: null})
        }
    }

    function validateSocialSecurityNumberSE(socialSecurityNumber) {
        const pattern = /^((19|20)?(\d{2})(0?[1-9]|1[012])[0-3][0-9])([-+]|\s){0,1}\d{4}$/;
        isValidSocialSecurityNumber(socialSecurityNumber, pattern);
    }

    function validateSocialSecurityNumberDK(socialSecurityNumber) {
        const pattern = /^[0-3][0-9][0-1][1-9][0-9][0-9]-[0-9][0-9][0-9][0-9]$/;
        isValidSocialSecurityNumber(socialSecurityNumber, pattern);
    }

    function isValidSocialSecurityNumber(socialSecurityNumber, pattern) {
        const isValidSSN = pattern.test(socialSecurityNumber);
        if (!isValidSSN) {
            setValidationMsgList({...validationMsgList, socialSecurityNumber: 'social security number is invalid'})
            return
        }
        if (validationMsgList.socialSecurityNumber) {
            setValidationMsgList({...validationMsgList, socialSecurityNumber: null})
        }
    }

    const toggleEditButtons = () => {
        setReadOnly(!readOnly)
        setIsVisible(!isVisible)
    }

    const ButtonGroup = () => {

        const btnStyle = {
            marginRight: '10px'
        }

        const onCancel = () => {
            toggleEditButtons()
            hydrateContact()
            setValidationMsgList({})
        }

        const onSave = () => {
            if (!checkValidationMsgList()) {
                return
            }
            saveCustomerContact()
            toggleEditButtons()
        }

        function checkValidationMsgList(){
            return Object.values(validationMsgList).every( currentValue => currentValue === null)
        }

        return (
            <React.Fragment>
                <button
                    className="btn btn-primary pull-right"
                    onClick={onSave}>
                    Save
                </button>
                <button
                    className="btn btn-default pull-right"
                    style={btnStyle}
                    onClick={onCancel}>
                    Cancel
                </button>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <ContentBox title="Personal Information">
                <Row>
                    <Column size={6}>
                        {error && (<span className="form-error">{error}</span>)}
                    </Column>
                    <Column size={6}>
                        {!isVisible &&
                        <button
                            className="btn btn-primary pull-right"
                            onClick={toggleEditButtons}>
                            <span className="fa fa-edit" aria-hidden="true"/>
                        </button>
                        }
                        {isVisible &&
                        <ButtonGroup/>
                        }
                    </Column>
                </Row>
                <Row>
                    <Column size={6}>
                        <LabelInput label="Salutation">
                            <Select
                                object={contact}
                                name="gender"
                                readOnly={readOnly}
                                valueList={salutationList}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        <LabelInput
                            label="Reference"
                            groupAddOnIcon="fa fa-info"
                        >
                            <Input
                                object={contact}
                                name="referenceNumber"
                                readOnly={true}
                                onChange={noop}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                <Row>
                    <Column size={6}>
                        <LabelInput
                            label="Firstname"
                            groupAddOnIcon="fa fa-info"
                        >
                            <Input
                                object={contact}
                                name="firstName"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                                onBlur={(e) => {
                                    validate(e.target)
                                }}
                            />
                        </LabelInput>
                        {validationMsgList.firstName && (
                            <span className="form-error">{validationMsgList.firstName}</span>)}
                    </Column>
                    <Column size={6}>
                        <LabelInput
                            label="Lastname"
                            groupAddOnIcon="fa fa-info"
                        >
                            <Input
                                object={contact}
                                name="lastName"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                                onBlur={(e) => {
                                    validate(e.target)
                                }}
                            />
                        </LabelInput>
                        {validationMsgList.lastName && (
                            <span className="form-error">{validationMsgList.lastName}</span>)}
                    </Column>
                </Row>
                <Row>
                    <Column size={6}>
                        <LabelInput
                            label="Street address"
                            groupAddOnIcon="fa fa-info"
                        >
                            <Input
                                object={contact}
                                name="streetAddress"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        <LabelInput
                            label="Street address extension"
                            groupAddOnIcon="fa fa-info"
                        >
                            <Input
                                object={contact}
                                name="streetAddressExtension"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                </Row>

                {contact.countryCode === 'AT' && (
                    <Row>
                        <Column size={6}>
                            <LabelInput
                                label="Staircase"
                                groupAddOnIcon="fa fa-info"
                            >
                                <Input
                                    object={contact}
                                    name="staircase"
                                    readOnly={readOnly}
                                    onChange={changeCustomerContact}
                                />
                            </LabelInput>
                        </Column>
                        <Column size={6}>
                            <LabelInput
                                label="Door"
                                groupAddOnIcon="fa fa-info"
                            >
                                <Input
                                    object={contact}
                                    name="door"
                                    readOnly={readOnly}
                                    onChange={changeCustomerContact}
                                />
                            </LabelInput>
                        </Column>
                    </Row>
                )}

                <Row>
                    <Column size={6}>
                        <LabelInput label="ZIP" groupAddOnIcon="fa fa-info">
                            <Input
                                object={contact}
                                name="zip"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        <LabelInput label="City" groupAddOnIcon="fa fa-info">
                            <Input
                                object={contact}
                                name="city"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                <Row>
                    <Column size={6}>
                        <LabelInput label="Country">
                            <Select
                                object={contact}
                                addEmpty={!contact.countryCode}
                                name="countryCode"
                                readOnly={readOnly}
                                valueList={countryCodeList}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        <LabelInput label="Language">
                            <Select
                                object={contact}
                                name="language"
                                readOnly={readOnly}
                                valueList={languageList}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                <Row>
                    <Column size={6}>
                        <LabelInput label="Email">
                            <Input
                                object={contact}
                                name="email"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                                onBlur={(e) => {
                                    validateEmail(e.target.value.trim())
                                }}
                            />
                            {validationMsgList.email && (<span className="form-error">{validationMsgList.email}</span>)}
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        <LabelInput
                            label="Phone"
                            groupAddOnIcon="fa fa-phone"
                            actionAddOnIcon="fa fa-phone"
                            onActionAddOnClick={() => {
                                callNumber(contact.phone)
                            }}
                        >
                            <Input
                                object={contact}
                                name="phone"
                                type="phone"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                                onBlur={(e) => {
                                    formatPhoneNumber(e)
                                    saveCustomerContact()
                                }}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                <Row>
                    <Column size={6}>
                        <LabelInput label="Date of birth">
                            <DateOfBirth
                                object={contact}
                                name="dob"
                                readOnly={readOnly}
                                onChange={changeCustomerContact}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        {contact.store && (
                            <LabelInput
                                label="Store"
                                groupAddOnIcon="fa fa-bank"
                            >
                                <Input
                                    object={contact}
                                    name="store"
                                    readOnly={true}
                                    onChange={noop}
                                />
                            </LabelInput>
                        )}
                    </Column>
                </Row>
                {(contact.countryCode === 'DK') && (
                    <Row>
                        <Column size={6}>
                            <LabelInput label="Social Security Number (Format: DDMMYY-SSSS)">
                                <Input
                                    placeholder="191200-3421"
                                    object={contact}
                                    name="socialSecurityNumber"
                                    readOnly={readOnly}
                                    onChange={changeCustomerContact}
                                    onBlur={(e) => {
                                        validateSocialSecurityNumberDK(e.target.value.trim())
                                    }}
                                />
                            </LabelInput>
                            {validationMsgList.socialSecurityNumber && (<span className="form-error">{validationMsgList.socialSecurityNumber}</span>)}
                        </Column>
                    </Row>
                )}
                {(contact.countryCode === 'SE') && (
                    <Row>
                        <Column size={6}>
                            <LabelInput label="Social Security Number (Format: YYMMDD-nnnC)">
                                <Input
                                    placeholder="001219-3421"
                                    object={contact}
                                    name="socialSecurityNumber"
                                    readOnly={readOnly}
                                    onChange={changeCustomerContact}
                                    onBlur={(e) => {
                                        validateSocialSecurityNumberSE(e.target.value.trim())
                                    }}
                                />
                            </LabelInput>
                            {validationMsgList.socialSecurityNumber && (<span className="form-error">{validationMsgList.socialSecurityNumber}</span>)}
                        </Column>
                    </Row>
                )}
            </ContentBox>
        </React.Fragment>
    )
}

CustomerContact.propTypes = {
    contact: PropTypes.object.isRequired,
    salutationList: PropTypes.array,
    changeCustomerContact: PropTypes.func.isRequired,
    saveCustomerContact: PropTypes.func.isRequired,
    hydrateContact: PropTypes.func.isRequired,
    countryCodeList: PropTypes.array.isRequired,
    languageList: PropTypes.array.isRequired,
}

export default lifecycle({
    componentDidMount() {
        this.props.hydrateContact()
    }
})(CustomerContact)



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerContact.js